
import { mapState } from 'vuex';
import { required } from '~/services/validators';
import formMixin from '~/services/form';

export default {
    name: 'BusinessReview',
    mixins: [formMixin],
    props: {
        /**
         * Show the Business name in place of date (for landing page)
         */
        showBusiness: {
            type: Boolean,
            default: false,
        },
        /**
         * Review object
         */
        review: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            message: '',
            showResponseForm: false,
        };
    },
    computed: {
        ...mapState(['auth']),
        isBusinessOwner() {
            return this.review.organisation_id === this.$store.state.auth?.user?.organisation_id;
        },
    },
    methods: {
        returnDate(payload) {
            const date = new Date(payload).toString().split(' ');
            return `${date[2]} ${date[1]}, ${date[3]}`;
        },
        async submitResponse() {
            const { message } = await this.$form.submit(`${this.$config.endpoints.testimonial}/${this.review.id}/reply`, '$post', {
                response: this.message,
            });
            this.showResponseForm = false;
            this.$emit('update-review', { reviewId: this.review.id, message: this.message });
            this.$store.dispatch('setFlashMessage', { message });
        },
        toggleReply() {
            this.showResponseForm = !this.showResponseForm;
        },
        confirmDelete() {
            this.$store.dispatch('showConfirm', {
                callback: this.deleteReview,
                text: this.$t('business.confirm_delete_review'),
            });
        },
        async deleteReview() {
            const { message } = await this.$axios.$delete(`${this.$config.endpoints.testimonial}/${this.review.id}`);
            this.$store.dispatch('setFlashMessage', { message });
            this.$emit('delete-review', this.review.id);
        },
    },
    validations: {
        message: [required],
    },
};
